import {Routes} from '@angular/router';
import {RouteUtil} from "../util/route.util";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";

export const routes: Routes = [{
  path: RouteUtil.CLIENT_MODULE,
  loadChildren: () => import('./client/client.module').then(module => module.ClientModule)
}, {
  path: RouteUtil.COMMON_MODULE,
  loadChildren: () => import('./common-module/common-module.module').then(module => module.CommonModuleModule)
}, {
  path: RouteUtil.DASHBOARD_MODULE,
  loadChildren: () => import('./dashboard/dashboard.module').then(module => module.DashboardModule)
}, {
  path: RouteUtil.DIALOG_MODULE,
  loadChildren: () => import('./dialog/dialog.module').then(module => module.DialogModule)
}, {
  path: '**',
  component: PageNotFoundComponent
}];
